import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchExport,
} from "./customerSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  allDay,
  CallApiExport,
  createChangeHandler,
  getValueStatus,
  paramsCustomerType,
  paramsMasterAll,
  paramsYesNoType2,
  setOptionsMaster,
  setOptionsMaster2,
  showErrorDialog,
} from "../../utility";
import { CustomerTable } from "./CustomerTable";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { ViewMapsMarkerCustomer } from "../../utility/ViewMapsMarkerCustomer";
import { fetchUser, selectDataUser } from "../user/userSlice";
import {
  fetchParam,
  fetchParam2,
  fetchParam3,
  selectDataParam,
  selectDataParam2,
  selectDataParam3,
} from "../param/paramSlice";
import MultiSelectAll from "../../utility/MultiSelectAll";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import { selectUser } from "../../modules/Auth";
import { InputDateRange } from "../../utility/InputDateRange";

export const CustomerPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);
  const dataParam = useSelector(selectDataParam);
  const dataParam3 = useSelector(selectDataParam3);
  const dataParam2 = useSelector(selectDataParam2);
  const dataBranch = useSelector(selectBranch);
  const user = useSelector(selectUser);

  // Filter
  const [code, setCode] = useState("");
  const [refCode, setRefCode] = useState("");
  const [repeatOrder, setRepeatOrder] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [sales, setSales] = useState("");
  const [frequency, setFrequency] = useState("");
  const [group, setGroup] = useState("");
  const [startUpdate, setStartUpdate] = useState("");
  const [endUpdate, setEndUpdate] = useState("");

  const [pointsVisit, setPointsVisit] = useState([]);
  const [show, setShow] = useState(false);
  const [optionsSales, setOptionsSales] = useState([]);
  const [optionsFreq, setOptionsFreq] = useState([]);
  const [optionsPaymentType, setOptionPaymentType] = useState([]);
  const [optionsOutlet, setOptionOutlet] = useState([]);
  const [hari, setHari] = useState([]);

  const [branch, setBranch] = useState("");
  const [optionsBranch, setOptionBranch] = useState([]);
  const handleChangeBranch = createChangeHandler(setBranch);
  const handleChangeRepeatOrder = createChangeHandler(setRepeatOrder);

  useEffect(() => {
    async function fetchMyAPI() {
      dispatch(resetData());

      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
      await dispatch(
        fetchUser({ ...paramsMasterAll, roles: "SALES", is_active: true })
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));

      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "FREQUEN",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam3({
          ...paramsMasterAll,
          param_group_code: "PAYMENT_TYPE",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam2({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (user && user.list_data_ownerships.length > 0) {
      setOptionsMaster(
        user.list_data_ownerships,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [user]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster2(dataUser, setOptionsSales, "username", [
        "username",
        "name",
      ]);
    }
  }, [dataUser]);

  useEffect(() => {
    // Add number
    const initData = data.map((item, index) => {
      return {
        lat: item.customer_latitude,
        lng: item.customer_longitude,
        label: item.customer_store_name,
        store: item.customer_store_name,
        address: item.customer_address,
      };
    });
    setPointsVisit(initData);
  }, [data]);
  useEffect(() => {
    if (dataParam3.length > 0) {
      setOptionsMaster(
        dataParam3,
        setOptionPaymentType,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam3]);
  useEffect(() => {
    if (dataParam2.length > 0) {
      setOptionsMaster(
        dataParam2,
        setOptionOutlet,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam2]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsFreq, "param_value", "param_value");
    }
  }, [dataParam]);

  const paramsFilter = {
    customer_code: code,
    ref_customer_code: refCode,
    customer_store_name: name,
    customer_type: type,
    username: sales,
    bisparfrequen_name: frequency,
    customer_group: group,
    bisparhari_kunjungan: hari.toString(),
    branch_code: branch,
    start_updated_at: startUpdate,
    end_updated_at: endUpdate,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeType = createChangeHandler(setType);
  const handleChangeSales = createChangeHandler(setSales);
  const handleChangeFreq = createChangeHandler(setFrequency);
  const handleChangeGroup = createChangeHandler(setGroup);

  function getValueOptionsMultiple(data) {
    let output = [];
    data.map((val) => {
      const result = allDay.filter((data) => val === data.value);
      output.push(result[0]);
    });
    return output;
  }

  const handleDaysChange = (selectedOptions) => {
    if (selectedOptions) {
      setHari(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setHari([]);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Customer">
          <CardHeaderToolbar>
            <Button
              className="btn btn-outline-danger mr-4"
              onClick={() =>
                CallApiExport(paramsFilter, fetchExport, dispatch, "Customer")
              }
            >
              Export
            </Button>
            {/* <Button
              className="btn btn-outline-danger mr-4"
              // onClick={() => setShow(true)}
              onClick={() => history.push("/master/customer/maps")}
            >
              Maps
            </Button> */}
            <Button
              className="btn btn-danger"
              onClick={() => history.push("/master/customer/create")}
            >
              Create
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filter */}
          <Form className="mb-5">
            <Form.Group as={Row}>
              <Col sm={4}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Type</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsPaymentType}
                      value={getValueStatus(type, optionsPaymentType)}
                      placeholder="Select ..."
                      onChange={handleChangeType}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Frequency</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsFreq}
                      value={getValueStatus(frequency, optionsFreq)}
                      placeholder="Select ..."
                      onChange={handleChangeFreq}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Hari Kunjungan</b>
                  </Form.Label>
                  <Col sm={8}>
                    <MultiSelectAll
                      options={allDay}
                      value={getValueOptionsMultiple(hari)}
                      onChange={handleDaysChange}
                      placeholder="Select Day..."
                    />
                  </Col>
                </Form.Group>
              </Col>

              {/* Right Row */}

              <Col sm={4}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Ref Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      type="text"
                      value={refCode}
                      onChange={(e) => setRefCode(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Branch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsBranch}
                      value={getValueStatus(branch, optionsBranch)}
                      placeholder="Select ..."
                      onChange={handleChangeBranch}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Group</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsOutlet}
                      value={getValueStatus(group, optionsOutlet)}
                      placeholder="Select ..."
                      onChange={handleChangeGroup}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* kiri */}
              <Col sm={4}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsSales}
                      value={getValueStatus(sales, optionsSales)}
                      placeholder="Select ..."
                      onChange={handleChangeSales}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Repeat Order</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={paramsYesNoType2}
                      value={getValueStatus(repeatOrder, paramsYesNoType2)}
                      placeholder="Select ..."
                      onChange={handleChangeRepeatOrder}
                      isClearable={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Updated Date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <InputDateRange
                      setEndDate={setEndUpdate}
                      setStartDate={setStartUpdate}
                      endDate={endUpdate}
                      startDate={startUpdate}
                      CallApi={fetchData}
                      paramsFilter={paramsFilter}
                      paramsStart={"start_updated_at"}
                      paramsEnd={"end_updated_at"}
                      hidden={true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Col sm={4}>
                    <Button
                      className="btn btn-outline-danger"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Col>
                  {/* <Col sm={4}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {/* Table */}

          <CustomerTable
            data={Array.isArray(data) ? data : []}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        </CardBody>
      </Card>

      <ViewMapsMarkerCustomer
        points={pointsVisit}
        setPoints={setPointsVisit}
        show={show}
        setShow={setShow}
      />
    </>
  );
};
